import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 2.5h6.492V9M13.5 10.5l8-8m-11 11l-8 8m0-6.5v6.5h6.492" stroke="currentColor" fill="none" /></svg>;